import { Stack } from "@mui/material"
import { ReactElement } from "react"

import SingleAttachment from "./singleAttachment"
import { TAttachment } from "../../../services/middleware/mappers/dnoInterface/dnoApplicationsMapper"
import { AttachmentIcon } from "../../icons/icons"
import { AppCard, AppCardContent, AppCardHeader } from "../../surfaces/appCard"

interface IDnoAttachmentsProps {
    attachments: TAttachment[]
    additionalAttachments: TAttachment[]
    applicationId: string
    isDnoMode: boolean
    title?: string
    disabled?: boolean
}
/**
 * Card for displaying DNO attachments
 */
const Attachments = ({
    attachments,
    additionalAttachments,
    applicationId,
    isDnoMode,
    title = "Attachments",
    disabled,
}: IDnoAttachmentsProps): ReactElement => (
    <AppCard>
        <AppCardHeader
            avatar={<AttachmentIcon fontSize="large" />}
            title={title}
            subheader="Click to download"
            titleTypographyProps={{
                variant: "h5",
                fontWeight: "500",
            }}
        />
        <AppCardContent>
            <Stack spacing={2}>
                {attachments.map((attachment, index) => (
                    <SingleAttachment
                        key={attachment.fileUrl}
                        filename={
                            attachment.fileName || `Cutout Image ${index + 1}`
                        }
                        fileUrl={attachment.fileUrl}
                        applicationId={applicationId}
                        isDnoMode={isDnoMode}
                        disabled={disabled}
                    />
                ))}
                {additionalAttachments.map((additionalAttachment, index) => (
                    <SingleAttachment
                        key={additionalAttachment.fileUrl}
                        filename={
                            additionalAttachment.fileName ||
                            `Additional File ${index + 1}`
                        }
                        fileUrl={additionalAttachment.fileUrl}
                        applicationId={applicationId}
                        isDnoMode={isDnoMode}
                        disabled={disabled}
                    />
                ))}
            </Stack>
        </AppCardContent>
    </AppCard>
)

Attachments.defaultProps = {
    title: "Attachments",
    disabled: false,
}

export default Attachments
